export default "__VITE_ASSET__wtaGp73R__"